import { useContext } from 'react';
// @ts-expect-error untyped JS module
import formatName from '../utils/formatName';
// @ts-expect-error untyped JS module
import formatFriendlyName from '../utils/formatFriendlyName';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedName({
  email,
  familyName,
  givenName,
  isFriendly = false,
  name,
  options,
  titleType
}) {
  useContext(I18nHMRContext);
  const formattedName = isFriendly ? formatFriendlyName({
    givenName,
    familyName,
    email
  }, options) : formatName({
    firstName: givenName,
    lastName: familyName,
    email,
    name,
    titleType
  }, options);
  return /*#__PURE__*/_jsx("span", {
    children: formattedName
  });
}
FormattedName.displayName = 'FormattedName';
export default FormattedName;